import { render, staticRenderFns } from "./Projektphasen.vue?vue&type=template&id=8590bf68&scoped=true&"
import script from "./Projektphasen.vue?vue&type=script&lang=js&"
export * from "./Projektphasen.vue?vue&type=script&lang=js&"
import style0 from "./Projektphasen.vue?vue&type=style&index=0&id=8590bf68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8590bf68",
  null
  
)

export default component.exports